// PLUGINS IMPORTS //
import React, { memo, useState } from "react"

// COMPONENTS IMPORTS //
import Panel from "./Panel/Panel"
import BurgerButton from "./BurgerButton/BurgerButton"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

export interface NavigationItemType {
  title: string
  icon: string
  dest: string
}

interface PropsType {
  links: Array<NavigationItemType>
}

const SideNavigation: React.FC<PropsType> = (props) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Panel links={props.links} open={open} setOpen={setOpen} />
      <BurgerButton open={open} setOpen={setOpen} />
    </>
  )
}

/////////////////////////////////////////////////////////////////////////////

export default memo(SideNavigation, memoComparison)
